/**
 * <s-snap-dots> — page dots for a native scroll-snap row (phone home hero, templates/index.liquid).
 * Dots use the product page dot style (.fz-gc__dots: one <i> per slide, the current one gets data-on).
 * No autoplay, no arrows: the visitor swipes (merchant 2026-11-01; Baymard / NN/g carousel guidance).
 * Markup: <s-snap-dots><div data-snap-track>…slides…</div><span class="fz-gc__dots" data-dots></span></s-snap-dots>
 */
class SSnapDots extends HTMLElement {
  #track = null;
  #dots = null;
  #frame = 0;

  connectedCallback() {
    this.#track = this.querySelector('[data-snap-track]');
    this.#dots = this.querySelector('[data-dots]');
    if (!this.#track || !this.#dots) return;
    const count = this.#track.children.length;
    if (count > 1) this.#dots.replaceChildren(...Array.from({ length: count }, () => document.createElement('i')));
    this.#track.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#track?.removeEventListener('scroll', this.#onScroll);
    cancelAnimationFrame(this.#frame);
  }

  #onScroll = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(this.#update);
  };

  #update = () => {
    const track = this.#track;
    if (!track || !this.#dots) return;
    const index = Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1));
    Array.from(this.#dots.children).forEach((dot, i) => dot.toggleAttribute('data-on', i === index));
  };
}

if (!customElements.get('s-snap-dots')) customElements.define('s-snap-dots', SSnapDots);
